module.exports = __webpack_public_path__ + "img/mescroll-empty.1641520899224.png";